import { Fill, Stroke, Style, Text } from 'ol/style';
import CircleStyle from 'ol/style/Circle';

export function lineStyle(isAccident: boolean) {
  return new Style({
    stroke: new Stroke({ color: isAccident ? '#ffd27f' : '#437c8d', width: 3 }),
  });
}

export function lineLabelStyle(name?: string) {
  return new Style({
    image: new CircleStyle({
      radius: 12,
      fill: new Fill({ color: '#06232d' }),
      stroke: new Stroke({ color: '#437c8d', width: 1 }),
    }),
    text: new Text({
      text: name,
      font: '14px Arial, sans-serif', // Font size and family,
      fill: new Fill({
        color: 'white',
      }),

      placement: 'point',
      textAlign: 'center',
      textBaseline: 'middle',
    }),
  });
}

export function fleetStyle(label: string, options?: { hover: boolean }): Style {
  return new Style({
    fill: new Fill({
      color: options?.hover ? '#003444' : '#06232d',
    }),
    stroke: new Stroke({
      color: '#0e4959',
      width: 2, // Border width
    }),
    text: new Text({
      font: '14px Arial, sans-serif', // Font size and family
      text: label, // The label to display
      fill: new Fill({
        color: 'white', // Text color
      }),
      textAlign: 'center', // Align text to the center
      textBaseline: 'middle', // Vertically center the text
    }),
  });
}
